import { ConversationStateModel } from '../../../store/store-models';

export function getConversationUnreadCount(conversation: ConversationStateModel): number {
  return (((conversation.lastReadMessageIndex ?? -1) > -1)
    ? (conversation.unreadMessagesCount)
    : (conversation.messagesCount)) ?? 0;
}
